import React from 'react';
import {StyleSheet, Pressable, Linking} from 'react-native';
import SlideModal from '@/Atoms/SlideModal';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import {SUPPORT_PHONE_NUMBERS} from '../constants/supportConstants';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';

interface SupportRequiredModalProps {
  visible: boolean;
  onClose?: () => void;
}

const SupportRequiredModal: React.FC<SupportRequiredModalProps> = ({visible, onClose}) => {
  const {isMobileOrTab} = useMediaQuery();

  const handleWhatsApp = (url: string) => {
    Linking.openURL(url).catch(err => {
      console.error('Error opening WhatsApp:', err);
    });
  };

  return (
    <SlideModal
      visible={visible}
      onClose={onClose ?? (() => {})}
      type="center"
      width={isMobileOrTab ? '80%' : '50%'}
      showCloseIcon={!!onClose}>
      <Box alignItems="center" style={styles.container}>
        {/* Icon Container with Shadow */}
        <Box
          justifyContent="center"
          alignItems="center"
          style={styles.iconContainer}>
          <MaterialCommunityIcons name="headset" size={48} color={CCColors.White} />
        </Box>

        {/* Title */}
        <CCText
          fontSize={FontSizes[24]}
          fontWeight="bold"
          color={CCColors.TextColor.Dark}
          textAlign="center"
          style={styles.title}>
          Connect with our live agent
        </CCText>

        {/* Description */}
        <CCText
          fontSize={FontSizes[16]}
          color={CCColors.TextColor.Grey}
          textAlign="center"
          style={styles.description}>
          Your current plan requires assistance from our customer support team for renewal.{'\n\n'}
          Please connect with us on WhatsApp to proceed with your renewal. Our team will help you complete the renewal process.
        </CCText>

        {/* Phone Numbers Container */}
        <Box style={styles.phoneNumbersWrapper}>
          {/* India Customer Care Number - Clickable */}
          <Pressable
            onPress={() => handleWhatsApp(SUPPORT_PHONE_NUMBERS.INDIA.whatsapp)}
            style={styles.phoneContainer}>
            <Box flexDirection="row" alignItems="center" gap={12}>
              <Box style={styles.phoneIconContainer}>
                <MaterialCommunityIcons
                  name="whatsapp"
                  size={20}
                  color="#25D366"
                />
              </Box>
              <Box alignItems="flex-start" gap={4}>
                <CCText fontWeight="medium" fontSize={FontSizes[16]}>
                  🇮🇳 {SUPPORT_PHONE_NUMBERS.INDIA.display}
                </CCText>
                <CCText
                  color={CCColors.TextColor.GreyText || CCColors.TextColor.Grey}
                  fontWeight="medium"
                  textBreakStrategy="simple"
                  fontSize={FontSizes[12]}>
                  {SUPPORT_PHONE_NUMBERS.INDIA.hours.anytime}
                </CCText>
              </Box>
            </Box>
          </Pressable>
        </Box>

        {/* Additional Info */}
        {/* <Box alignItems="center" style={styles.footer}>
          <CCText
            fontWeight="medium"
            fontSize={FontSizes[12]}
            style={styles.footerText}>
            Standard carrier rates may apply.
          </CCText>
        </Box> */}
      </Box>
    </SlideModal>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    padding: 32,
    backgroundColor: CCColors.White,
    borderRadius: 16,
    borderWidth: 2,
    borderColor: CCColors.Primary.Default,
    // maxWidth: 600,
    width: '100%',
  },
  iconContainer: {
    width: 96,
    height: 96,
    borderRadius: 48,
    backgroundColor: '#25D366',
    marginBottom: 24,
    shadowColor: '#25D366',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginBottom: 16,
  },
  description: {
    marginBottom: 32,
    maxWidth: '90%',
  },
  phoneNumbersWrapper: {
    width: '100%',
    gap: 16,
    marginBottom: 24,
  },
  phoneContainer: {
    backgroundColor: CCColors.Primary.lightBrown || '#F5F0E8',
    borderRadius: 12,
    padding: 16,
    width: '100%',
    borderWidth: 2,
    borderColor: CCColors.Primary.Default,
  },
  phoneIconContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: CCColors.White,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: CCColors.Primary.Default,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 4,
  },
  footer: {
    marginTop: 16,
  },
  footerText: {
    opacity: 0.7,
  },
});

export default SupportRequiredModal;

